// Icons with Background
import { Typography } from '@mui/material'
import { cva } from 'class-variance-authority'

import { Badge } from '../ui/badge'

import { ReactComponent as CoreTeamSeat } from '@/assets/icons/core_team_seat_new.svg'
import { ReactComponent as AdvancedTeamSeat } from '@/assets/icons/advanced_team_seat_new.svg'
import { ReactComponent as UnlimitedTeamSeat } from '@/assets/icons/unlimited_team_seat_new.svg'
import { ReactComponent as OrganizationStudentSeat } from '@/assets/icons/organization_student_seat.svg'
import { ReactComponent as OrganizationTeacherSeat } from '@/assets/icons/organization_teacher_seat.svg'
import { ReactComponent as OrganizationLeaderSeat } from '@/assets/icons/organization_leader_seat.svg'
// Icons without Background
// import { ReactComponent as FreeSeatIcon } from '@/assets/icons/seat_icon_free.svg'
// import { ReactComponent as CoreSeatIcon } from '@/assets/icons/seat_icon_core.svg'
// import { ReactComponent as AdvancedSeatIcon } from '@/assets/icons/seat_icon_advanced.svg'
// import { ReactComponent as UnlimitedSeatIcon } from '@/assets/icons/seat_icon_unlimited.svg'
import { ReactComponent as OrganizationTeacherSeatIcon } from '@/assets/icons/seat_icon_organization_teacher.svg'
import { ReactComponent as OrganizationStudentSeatIcon } from '@/assets/icons/seat_icon_organization_student.svg'
// General Team and Organization Icons
import { ReactComponent as GeneralFreeIcon } from '@/assets/icons/general_free.svg'
import { ReactComponent as GeneralTeamIcon } from '@/assets/icons/general_team.svg'
import { ReactComponent as GeneralOrganizationIcon } from '@/assets/icons/general_organization.svg'
import { teamSeatTypes, type TeamSeatType } from '@/models/teams/teams.model'
import { ReactComponent as OrgAssignmentsIcon } from '@/assets/icons/assignment-white.svg'
import { ReactComponent as GeneralTeamSeatIcon } from '@/assets/icons/general_team_seat.svg'
import { ReactComponent as GeneralTeamUnlimitedIcon } from '@/assets/icons/general_team_seat_unlimited.svg'
import { ReactComponent as GeneralOrgIcon } from '@/assets/icons/general_org.svg'
// Plain White icons
import { ReactComponent as TeamIconWhite } from '@/assets/icons/team-white.svg'
import { ReactComponent as TeacherIconWhite } from '@/assets/icons/glasses-white.svg'
import { ReactComponent as StudentIconWhite } from '@/assets/icons/graduation-white.svg'
// import { ReactComponent as AssignmentIconWhite } from '@/assets/icons/assignment.svg'

function FreeSeatIcon(props: React.SVGProps<SVGSVGElement>) {
  const color = props.color || '#EB3EB7'

  return (
    <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_734_11669)">
        <path
          d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          clipRule="evenodd"
          d="M5.99829 4.53395C5.49845 3.9496 4.66494 3.79241 4.03867 4.3275C3.41241 4.8626 3.32424 5.75724 3.81605 6.3901C4.13106 6.79545 4.93779 7.54712 5.47712 8.03518C5.65634 8.19737 5.74596 8.27846 5.85329 8.31099C5.94556 8.33895 6.05101 8.33895 6.14328 8.31099C6.25062 8.27846 6.34023 8.19737 6.51946 8.03518C7.05878 7.54712 7.86552 6.79545 8.18053 6.3901C8.67233 5.75724 8.59493 4.85697 7.9579 4.3275C7.32087 3.79804 6.49813 3.9496 5.99829 4.53395Z"
          fillRule="evenodd"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_734_11669">
          <rect fill="white" height="12" width="12" />
        </clipPath>
      </defs>
    </svg>
  )
}

function CoreSeatIcon(props: React.SVGProps<SVGSVGElement>) {
  const color = props.color || '#7A5AF8'

  return (
    <svg fill="none" height="24" viewBox="0 0 25 24" width="25" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.3335 2L15.9335 5.6C18.3335 -0.7 25.0335 6 18.7335 8.4L22.3335 12L18.7335 15.6C16.3335 9.3 9.6335 16 15.9335 18.4L12.3335 22L8.7335 18.4C6.3335 24.7 -0.366504 18 5.9335 15.6L2.3335 12L5.9335 8.4C8.3335 14.7 15.0335 8 8.7335 5.6L12.3335 2Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

function AdvancedSeatIcon(props: React.SVGProps<SVGSVGElement>) {
  const color = props.color || '#7A5AF8'

  return (
    <svg fill="none" height="24" viewBox="0 0 25 24" width="25" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.3335 15L9.3335 12M12.3335 15C13.7303 14.4687 15.0704 13.7987 16.3335 13M12.3335 15V20C12.3335 20 15.3635 19.45 16.3335 18C17.4135 16.38 16.3335 13 16.3335 13M9.3335 12C9.86564 10.6194 10.5357 9.29607 11.3335 8.05C12.4987 6.18699 14.1211 4.65305 16.0465 3.5941C17.9719 2.53514 20.1362 1.98637 22.3335 2C22.3335 4.72 21.5535 9.5 16.3335 13M9.3335 12H4.3335C4.3335 12 4.8835 8.97 6.3335 8C7.9535 6.92 11.3335 8 11.3335 8M4.8335 16.5C3.3335 17.76 2.8335 21.5 2.8335 21.5C2.8335 21.5 6.5735 21 7.8335 19.5C8.5435 18.66 8.5335 17.37 7.7435 16.59C7.3548 16.219 6.84279 16.0046 6.30572 15.988C5.76865 15.9714 5.24437 16.1537 4.8335 16.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

function UnlimitedSeatIcon(props: React.SVGProps<SVGSVGElement>) {
  const color = props.color || '#7A5AF8'

  return (
    <svg fill="none" height="24" viewBox="0 0 25 24" width="25" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.5112 8C23.6072 8 23.6072 16 18.5112 16C13.4162 16 11.3782 8 5.77225 8C1.18725 8 1.18725 16 5.77225 16C11.3782 16 13.4162 8 18.5122 8H18.5112Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export {
  CoreTeamSeat,
  FreeSeatIcon,
  AdvancedTeamSeat,
  UnlimitedTeamSeat,
  CoreSeatIcon,
  AdvancedSeatIcon,
  UnlimitedSeatIcon,
  GeneralFreeIcon,
  GeneralTeamIcon,
  GeneralOrganizationIcon,
  OrganizationTeacherSeatIcon,
  OrganizationStudentSeatIcon,
  OrganizationTeacherSeat,
  OrganizationStudentSeat,
  OrganizationLeaderSeat,
  OrgAssignmentsIcon,
  GeneralTeamSeatIcon,
  GeneralTeamUnlimitedIcon,
  GeneralOrgIcon,
  // Plain White icons
  TeamIconWhite,
  TeacherIconWhite,
  StudentIconWhite,
}

export const TeamSeatIcons: Record<
  TeamSeatType['id'],
  { icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>; color: string; label: string; bgcolor: string }
> = {
  free_tier: {
    icon: FreeSeatIcon,
    color: '#EE46BC',
    label: teamSeatTypes.find(type => type.id === 'free_tier')?.name || 'Free',
    bgcolor: '#FCE7F6',
  },
  core_team_seat: {
    icon: CoreSeatIcon,
    color: '#7A5AF8',
    label: teamSeatTypes.find(type => type.id === 'core_team_seat')?.name || 'Core',
    bgcolor: '#EBE9FE',
  },
  advanced_team_seat: {
    icon: AdvancedSeatIcon,
    color: '#7A5AF8',
    label: teamSeatTypes.find(type => type.id === 'advanced_team_seat')?.name || 'Advanced',
    bgcolor: '#EBE9FE',
  },
  unlimited_team_seat: {
    icon: UnlimitedSeatIcon,
    color: '#7A5AF8',
    label: teamSeatTypes.find(type => type.id === 'unlimited_team_seat')?.name || 'Unlimited',
    bgcolor: '#EBE9FE',
  },
}

const teamSeatChipsVariants = cva(
  'flex items-center gap-2 rounded-full w-fit border shadow-none text-xs gap-1 cursor-pointer ',
  {
    variants: {
      type: {
        free_tier: `text-[#C11574] border-[#FCCEEE] bg-[#FDF2FA] hover:bg-[#FDF2FA ]`,
        core_team_seat: `text-[#3538CD] border-[#C7D7FE] bg-[#EEF4FF] hover:bg-[#EEF4FF]`,
        advanced_team_seat: `text-[#3538CD] border-[#C7D7FE] bg-[#EEF4FF] hover:bg-[#EEF4FF]`,
        unlimited_team_seat: `text-[#3538CD] border-[#C7D7FE] bg-[#EEF4FF] hover:bg-[#EEF4FF]`,
      },
    },
    defaultVariants: {
      type: 'free_tier',
    },
  },
)

export function TeamSeatChip({
  type,
  onClick,
}: {
  type: TeamSeatType['id']
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}) {
  const seatType = TeamSeatIcons[type] || TeamSeatIcons.free_tier

  return (
    <Badge className={teamSeatChipsVariants({ type: type || 'free_tier' })} onClick={e => onClick?.(e)}>
      <seatType.icon style={{ width: 12, height: 12 }} />
      <Typography fontSize={12} fontWeight={500}>
        {seatType.label}
      </Typography>
    </Badge>
  )
}

const teamRoleChipsVariants = cva('flex items-center gap-2 rounded-full w-fit border shadow-none text-xs gap-1 ', {
  variants: {
    role: {
      admin: `text-[#A12F7E] border-[#FCCEEE] bg-[#FDF2FA] hover:bg-[#FDF2FA]`,
      member: `text-[#175CD3] border-[#B2DDFF] bg-[#EEF4FF] hover:bg-[#EFF8FF]`,
    },
  },
  defaultVariants: {
    role: 'member',
  },
})

export function TeamRoleChip({ type }: { type: 'admin' | 'member' }) {
  const roleType = type === 'admin' ? 'admin' : 'member'

  return (
    <Badge className={teamRoleChipsVariants({ role: type || 'member' })}>
      <Typography fontSize={12} fontWeight={500}>
        {roleType === 'admin' ? 'Admin' : 'Member'}
      </Typography>
    </Badge>
  )
}

export function OrgPLGIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={53} viewBox="0 0 52 53" width={52} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_770_14364)">
        <path
          d="M2 11.5C2 5.97715 6.47715 1.5 12 1.5H40C45.5229 1.5 50 5.97715 50 11.5V39.5C50 45.0229 45.5228 49.5 40 49.5H12C6.47715 49.5 2 45.0228 2 39.5V11.5Z"
          fill="#2E90FA"
          shapeRendering="crispEdges"
        />
        <path
          d="M12 2H40C45.2467 2 49.5 6.25329 49.5 11.5V39.5C49.5 44.7467 45.2467 49 40 49H12C6.7533 49 2.5 44.7467 2.5 39.5V11.5C2.5 6.2533 6.75329 2 12 2Z"
          shapeRendering="crispEdges"
          stroke="#D1E9FF"
        />
        <path
          d="M21 24.5V21.5C21 18.7386 23.2386 16.5 26 16.5C28.419 16.5 30.4367 18.2178 30.9 20.5M21.8 34.5H30.2C31.8802 34.5 32.7202 34.5 33.362 34.173C33.9265 33.8854 34.3854 33.4265 34.673 32.862C35 32.2202 35 31.3802 35 29.7V29.3C35 27.6198 35 26.7798 34.673 26.138C34.3854 25.5735 33.9265 25.1146 33.362 24.827C32.7202 24.5 31.8802 24.5 30.2 24.5H21.8C20.1198 24.5 19.2798 24.5 18.638 24.827C18.0735 25.1146 17.6146 25.5735 17.327 26.138C17 26.7798 17 27.6198 17 29.3V29.7C17 31.3802 17 32.2202 17.327 32.862C17.6146 33.4265 18.0735 33.8854 18.638 34.173C19.2798 34.5 20.1198 34.5 21.8 34.5Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height={52}
          id="filter0_d_770_14364"
          width={52}
          x={0}
          y={0.5}
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_770_14364" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_770_14364" mode="normal" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}
